import { Modal } from '@brighterion/br-ui';
import React from 'react';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import styles from './index.css';

type Props = {
    isOpen: boolean;
    dateRangeMinValue: Date;
    currencyChange: boolean;
    closeModal: () => void;
    generateReport: () => void;
};

export const ReportNoDataWarningModal = ({
    isOpen,
    closeModal,
    currencyChange,
    dateRangeMinValue,
    generateReport
}: Props) => {
    const { t } = useTranslation();
    const formattedDate = format(dateRangeMinValue, 'yyyy-MM-dd');

    return (
        <Modal isOpen={isOpen} closeModal={closeModal} status='warning' containerClass={styles.containerClass}>
            <Modal.Title
                id='create-report-warning-modal-title'
                statusIcon='warning'
                title={
                    currencyChange
                        ? t('Data is unavailable in prior base currency')
                        : t('Data is unavailable for selected date range')
                }
                onClose={closeModal}
            />
            <div className={styles.errModalContent}>
                {currencyChange
                    ? t('report base currency changed', { formattedDate })
                    : t('report data unavailable prior to date', { formattedDate })}
            </div>
            <Modal.Footer
                id='create-report-warning-modal-footer'
                onClose={closeModal}
                onCloseText={t('Cancel')}
                onAction={() => {
                    generateReport();
                    closeModal();
                }}
                onActionText={t('Generate New Report')}
            />
        </Modal>
    );
};
